<template>
  <div style="background-color: #f4edf4; height: 100vh; width: 100vw">
    <loading v-if="displayLoading"></loading>
    <img :src="event.config.images?.landing_kv" alt="" class="w-100" @click="() => goto()">
  </div>
</template>

<script>
import liff from "@line/liff";
import redeemApi from "@/apis/liff/v2/redeem";

export default {
  data() {
    return {
      displayLoading: true,
      event: {
        config: {},
      },
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      // 如果已經透過 LIFF Client 開啟，則直接導去 Elanco 活動頁
      if (liff.isInClient()) {
        this.$router.push({
          name: "LiffProjElanco2026Redeem",
          params: this.$route.params,
          query: this.$route.query
        });
        return;
      }


      const eventRes = await redeemApi.getRedeemEvent({
        event_code: this.$route.query.event_code,
      });

      this.event = eventRes.data.data.event;

      console.log(eventRes);


      this.displayLoading = false;
    },
    goto() {
      const liffId = this.$store.getters['liffGeneral/liffId'];
      window.location.href = `https://liff.line.me/${liffId}/proj/elanco/2026/${this.$route.params.code}?event_code=${this.$route.query.event_code}`;
    }
  },
};
</script>
